import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  createSearchKey,
  FUNCTION_RESULT_STATUS,
  IFieldUpdate,
} from '@nova/common-interfaces';
import { ISubscription } from '@rfm/shared-interfaces';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { SubscriptionService } from '../../../../shared/services/products/subscription.service.mjs';

@Component({
  selector: 'app-subscription-change-price-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    BlockUIModule,
    ConfirmDialogModule,
    ToastModule,
    InputNumberModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: './subscription-change-price.modal.html',
  styleUrls: ['./subscription-change-price.modal.scss'],
})
export class SubscriptionChangePriceModal implements OnInit {
  @Input()
  objectType = signal('');
  @Input()
  objectId = signal('');
  @Input()
  visible = signal(false);
  subscription: ISubscription | undefined;
  currentPrice: number = 0;
  newPrice: number = 0;
  planPrice: number = 0;
  customerName: string = '';
  planName: string = '';

  isLoading = false;
  @Output() onData = new EventEmitter<any>();

  sendDataToParent() {
    this.onData.emit(true);
  }

  constructor(
    private subscriptionService: SubscriptionService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit() {}

  changePrice() {
    this.confirmationService.confirm({
      target: event!.target as EventTarget,
      message: 'Are you sure that you want to change this subscriptions price?',
      header: 'Change Subscription Price Confirmation',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancel',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Change Price',
      },
      accept: async () => {
        this.isLoading = true;
        console.log('Updating field');
        const searchKey = createSearchKey('actual_amount', this.newPrice);
        console.log('Search key', searchKey);

        await this.subscriptionService
          .updateByField({
            key: this.subscription!.id,
            updateValues: searchKey,
          } as IFieldUpdate)
          .then((result) => {
            console.log('Result', result);
            if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
              this.messageService.add({
                severity: 'success',
                summary: 'Subscription Price Changed',
                detail: 'Customer subscription price has been changed',
                life: 3000,
              });
              this.isLoading = false;
              this.sendDataToParent();
              this.visible.set(false);
              return Promise.resolve();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Subscription Price Not Changed',
                detail: 'Customer subscription price failed to update',
                life: 3000,
              });
              this.isLoading = false;
              return Promise.reject(result);
            }
          });
      },
      reject: () => {
        this.isLoading = false;
        this.visible.set(false);
      },
    });
  }

  dialogClosed() {
    console.log('Closed');
    this.currentPrice = 0;
    this.customerName = '';
    this.planPrice = 0;
    this.planName = '';
    this.newPrice = 0;
  }

  dialogShown() {
    this.isLoading = true;
    console.log(this.objectId());
    if (this.objectType() === 'customer') {
      this.subscriptionService
        .getByCustomer(this.objectId())
        .then(async (result) => {
          if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
            this.subscription = result.data![0];
            this.customerName = result.data![0].customer_id?.name!;
            this.planName = result.data![0].plan?.name!;
            this.planPrice = result.data![0].amount;
            this.currentPrice = result.data![0].actual_amount;
            this.newPrice = this.currentPrice;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
    if (this.objectType() === 'subscription') {
      this.subscriptionService
        .get(this.objectId())
        .then(async (result) => {
          if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
            this.subscription = result.data!;
            this.customerName = result.data!.customer_id?.name!;
            this.planName = result.data!.plan?.name!;
            this.planPrice = result.data!.amount;
            this.currentPrice = result.data!.actual_amount;
            this.newPrice = this.currentPrice;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
